/* Artemesia 2026 collection board: sort submit + mobile filter drawer. No dependencies. */
(function () {
  document.documentElement.classList.add('js');

  var root = document.querySelector('[data-am-collection]');
  if (!root) { return; }

  /* Sort applies on change; the Go button is the no-JS fallback and is hidden by CSS. */
  var sortForm = root.querySelector('[data-am-sort]');
  if (sortForm) {
    var select = sortForm.querySelector('select[name="sort_by"]');
    if (select) {
      select.addEventListener('change', function () { sortForm.submit(); });
    }
  }

  var panel = root.querySelector('[data-am-facets]');
  var underlay = root.querySelector('.am-facets__underlay');
  var openBtn = root.querySelector('[data-am-facets-open]');
  if (!panel || !openBtn) { return; }

  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    if (underlay) { underlay.classList.add('is-open'); }
    document.body.style.overflow = 'hidden';
    openBtn.setAttribute('aria-expanded', 'true');
    var first = panel.querySelector('[data-am-facets-close]');
    if (first) { first.focus(); }
  }

  function close() {
    panel.classList.remove('is-open');
    if (underlay) { underlay.classList.remove('is-open'); }
    document.body.style.overflow = '';
    openBtn.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  openBtn.setAttribute('aria-expanded', 'false');
  openBtn.addEventListener('click', open);

  [].forEach.call(root.querySelectorAll('[data-am-facets-close]'), function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) { close(); }
  });

  /* The drawer is a desktop sidebar again above 860px; drop the scroll lock if the
     viewport grows while it happens to be open. */
  var mq = window.matchMedia('(min-width: 861px)');
  var onChange = function (ev) { if (ev.matches) { close(); } };
  if (mq.addEventListener) { mq.addEventListener('change', onChange); }
  else if (mq.addListener) { mq.addListener(onChange); }
})();
